export const getMarketMultiplySelectFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
